import { UUID } from '@hfc/common/src/types/UUID';
import { APPLICATION_TYPES } from '@hfc/common/src/types/ApplicationTypes';
import { EnrollmentRepository } from '@/application/shared/domain/EnrollmentRepository';
import { UseCase } from '@/shared/application/UseCase';
import { SfApiResponse } from '@hfc/ui-core';
import { ChallengeQuestionSettings, ChallengeType } from '@/application/shared/domain/ChallengeQuestionSettings';

export class ChallengeQuestionSettingsOtpUseCase implements UseCase<[APPLICATION_TYPES, ChallengeType, UUID], SfApiResponse<ChallengeQuestionSettings>> {

  private repository: EnrollmentRepository;

  public constructor (repository: EnrollmentRepository) {
    this.repository = repository;
  }

  public async run (input: [APPLICATION_TYPES, ChallengeType, UUID]): Promise<SfApiResponse<ChallengeQuestionSettings>> {
    const [type, challengeType, uuid] = input;

    return await this.repository.challengeQuestionSettingsOtp(type, challengeType, uuid);
  }

}
